



export const GridIcon = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19.9922 19.9922"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.49707 2.49902H3.74854C3.05845 2.49902 2.49902 3.05845 2.49902 3.74854V7.49707C2.49902 8.18716 3.05845 8.74659 3.74854 8.74659H7.49707C8.18716 8.74659 8.74659 8.18716 8.74659 7.49707V3.74854C8.74659 3.05845 8.18716 2.49902 7.49707 2.49902Z"
      stroke="currentColor"
      strokeWidth="1.87427"
    />
    <path
      d="M16.2437 2.49902H12.4951C11.805 2.49902 11.2456 3.05845 11.2456 3.74854V7.49707C11.2456 8.18716 11.805 8.74659 12.4951 8.74659H16.2437C16.9337 8.74659 17.4932 8.18716 17.4932 7.49707V3.74854C17.4932 3.05845 16.9337 2.49902 16.2437 2.49902Z"
      stroke="currentColor"
      strokeWidth="1.87427"
    />
    <path
      d="M7.49707 11.2456H3.74854C3.05845 11.2456 2.49902 11.805 2.49902 12.4951V16.2437C2.49902 16.9337 3.05845 17.4932 3.74854 17.4932H7.49707C8.18716 17.4932 8.74659 16.9337 8.74659 16.2437V12.4951C8.74659 11.805 8.18716 11.2456 7.49707 11.2456Z"
      stroke="currentColor"
      strokeWidth="1.87427"
    />
    <path
      d="M16.2437 11.2456H12.4951C11.805 11.2456 11.2456 11.805 11.2456 12.4951V16.2437C11.2456 16.9337 11.805 17.4932 12.4951 17.4932H16.2437C16.9337 17.4932 17.4932 16.9337 17.4932 16.2437V12.4951C17.4932 11.805 16.9337 11.2456 16.2437 11.2456Z"
      stroke="currentColor"
      strokeWidth="1.87427"
    />
  </svg>
);



export const ArrowRightIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15.9961 15.9961"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M2.99927 7.99805H12.9968M8.99781 11.9971L12.9968 7.99805L8.99781 3.99902"
      stroke="currentColor"
      strokeWidth="1.49963"
      strokeLinecap="round"
    />
  </svg>
);

export const EyeIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15.9961 15.9961"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M0.666504 7.99805C0.666504 7.99805 3.33252 2.66602 7.99805 2.66602C12.6636 2.66602 15.3296 7.99805 15.3296 7.99805C15.3296 7.99805 12.6636 13.3301 7.99805 13.3301C3.33252 13.3301 0.666504 7.99805 0.666504 7.99805Z"
      stroke="currentColor"
      strokeWidth="0.999756"
    />
    <path
      d="M7.99805 9.99756C9.10235 9.99756 9.99756 9.10235 9.99756 7.99805C9.99756 6.89375 9.10235 5.99854 7.99805 5.99854C6.89375 5.99854 5.99854 6.89375 5.99854 7.99805C5.99854 9.10235 6.89375 9.99756 7.99805 9.99756Z"
      stroke="currentColor"
      strokeWidth="0.999756"
    />
  </svg>
);

export const EyeOffIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15.9961 15.9961"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6.5 6.6a2 2 0 0 0 2.83 2.83M4.2 4.28C2.3 5.4 1 7.998 1 7.998s2.666 5.332 7.332 5.332c1.06 0 2.04-.27 2.9-.7M7.1 2.73a6.6 6.6 0 0 1 .9-.06c4.666 0 7.332 5.33 7.332 5.33a12.9 12.9 0 0 1-1.86 2.62M1 1l13.996 13.996"
      stroke="currentColor"
      strokeWidth="0.999756"
      strokeLinecap="round"
    />
  </svg>
);

export const ShieldIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13.9922 13.9922"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M9.91114 6.41309H4.08106C3.43708 6.41309 2.91504 6.93514 2.91504 7.57911V11.6602C2.91504 12.3041 3.43708 12.8262 4.08106 12.8262H9.91114C10.5551 12.8262 11.0772 12.3041 11.0772 11.6602V7.57911C11.0772 6.93514 10.5551 6.41309 9.91114 6.41309Z"
      stroke="currentColor"
      strokeWidth="0.874513"
    />
    <path
      d="M4.66407 6.41309V4.08106C4.66407 3.46256 4.90976 2.8694 5.3471 2.43206C5.78444 1.99472 6.37761 1.74902 6.9961 1.74902C7.61459 1.74902 8.20776 1.99472 8.6451 2.43206C9.08244 2.8694 9.32813 3.46256 9.32813 4.08106V6.41309"
      stroke="currentColor"
      strokeWidth="0.874513"
      strokeLinecap="round"
    />
  </svg>
);
